/*
----------------------------
Module - animation
----------------------------
*/

// import $ from 'jquery';

// (function(){
//     'use strict';
    
    
// }());
